import { Box, Grid2 } from "@mui/material";
import { ReactComponent as FlowSvg } from "../../assets/logosSvg/LOGOEASYFLOW.svg";
import { ReactComponent as MomSvg } from "../../assets/logosSvg/LOGOEASYMON.svg";
import { ReactComponent as BiSvg } from "../../assets/logosSvg/LOGOEASYBI.svg";
import { ReactComponent as ReportSvg } from "../../assets/logosSvg/easyReport.svg";

import { ReactComponent as MapsSvg } from "../../assets/logosSvg/LOGOEASYMAPS.svg";
import { ReactComponent as LogSvg } from "../../assets/logosSvg/logoEasyLog.svg";

import { ReactComponent as ZabbixLogo } from "../../assets/logosSvg/logoZabbix.svg";
import MyCard from "./MyCard";

import Inbox from "./inbox/inbox";
import { useTheme } from "@emotion/react";
import { useOutletContext } from "react-router-dom";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  cardGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "20px",
    width: "100%",
  },
  body: {
    gap: "1.5rem",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  sizeGridContainer: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 },
  sizeGridItem: {
    xs: 12,
    sm: 12,
    md: 6,
    lg: 4,
    xl: 3,
  },
};

export default function NocLinks() {
  const theme = useTheme();
  const easyFlowLogo =
    theme.palette.mode === "dark"
      ? `${
          window?.config?.REACT_APP_LOGO_EASY_FLOW_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_EASY_FLOW_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_EASY_FLOW_URL || ""}`;
  const easyMonLogo =
    theme.palette.mode === "dark"
      ? `${
          window?.config?.REACT_APP_LOGO_EASY_MON_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_EASY_MON_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_EASY_MON_URL || ""}`;
  const easyBiLogo =
    theme.palette.mode === "dark"
      ? `${
          window?.config?.REACT_APP_LOGO_EASY_BI_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_EASY_BI_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_EASY_BI_URL || ""}`;
  const easyReportLogo =
    theme.palette.mode === "dark"
      ? `${
          window?.config?.REACT_APP_LOGO_EASY_REPORT_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_EASY_REPORT_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_EASY_REPORT_URL || ""}`;
  const easyMapsLogo =
    theme.palette.mode === "dark"
      ? `${
          window?.config?.REACT_APP_LOGO_EASY_MAPS_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_EASY_MAPS_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_EASY_MAPS_URL || ""}`;
  const easyLogsLogo =
    theme.palette.mode === "dark"
      ? `${
          window?.config?.REACT_APP_LOGO_EASY_LOGS_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_EASY_LOGS_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_EASY_LOGS_URL || ""}`;
  const isPartner = window?.config?.REACT_APP_IS_PARTNER === "true" || false;
  const linkEasyBI =
    window?.config?.REACT_APP_GRAFANA_LINK?.split("/login") || "";
  const verifyModules = window?.config?.REACT_APP_VERIFY_MODULES;
  let modulos = localStorage.getItem("modulos") || "{}";
  modulos = typeof modulos === "string" ? JSON.parse(modulos) : modulos;

  return (
    <Box sx={styles.container}>
      <Box sx={styles.body}>
        <Grid2
          container
          rowSpacing={1.5}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1.5}
          flexWrap={"wrap"}
          wrap="wrap"
          sx={{ width: "100%" }}
          columns={styles.sizeGridContainer}
        >
          <Grid2 item size={styles.sizeGridItem}>
            <MyCard
              link={window?.config?.REACT_APP_GRAFANA_LINK || ""}
              img={<MomSvg />}
              clientImg={easyMonLogo}
              disabled={
                verifyModules === "true"
                  ? (!modulos?.planoCombo && !modulos?.planoEasyMon) ||
                    modulos?.status === 2
                  : false
              }
              bgcolor={theme.palette.background.paper}
              circleColorOne={"#E65835"}
              circleColorTwo={"#AA3F76"}
            />
          </Grid2>
          <Grid2 item size={styles.sizeGridItem}>
            <MyCard
              img={<FlowSvg />}
              clientImg={easyFlowLogo}
              bgcolor={theme.palette.background.paper}
              link={window?.config?.REACT_APP_GRAFANA_LINK || ""}
              disabled={
                verifyModules === "true"
                  ? (!modulos?.planoCombo && !modulos?.planoEasyFlow) ||
                    modulos?.status === 2
                  : false
              }
              circleColorOne={"#2DC989"}
              circleColorTwo={"#AA3F76"}
              productName={"EasyFlow"}
            />
          </Grid2>
          <Grid2 item size={styles.sizeGridItem}>
            <MyCard
              img={<ZabbixLogo />}
              size={"small"}
              bgcolor={theme.palette.background.paper}
              link={window?.config?.REACT_APP_ZABBIX_LINK || ""}
              circleColorOne={"#F43F59"}
              circleColorTwo={"#822e87"}
            />
          </Grid2>
          <Grid2 item size={styles.sizeGridItem}>
            <MyCard
              img={<BiSvg />}
              clientImg={easyBiLogo}
              size={"medium"}
              bgcolor={theme.palette.background.paper}
              productName={"EasyBI"}
              link={
                window?.config?.REACT_APP_EASYBI_LINK ||
                `${linkEasyBI?.[0]}/d/HOME_EASYBI` ||
                ""
              }
              disabled={
                verifyModules === "true"
                  ? !modulos?.planoEasyBI || modulos?.status === 2
                  : false
              }
              circleColorOne={"#2DC989"}
              circleColorTwo={"#AA3F76"}
            />
          </Grid2>
          <Grid2 item size={styles.sizeGridItem}>
            <MyCard
              img={<ReportSvg />}
              clientImg={easyReportLogo}
              bgcolor={theme.palette.background.paper}
              target=""
              navigateTo="/easyReportV2/relatorios"
              disabled={
                verifyModules === "true"
                  ? !modulos?.planoEasyReport || modulos?.status === 2
                  : false
              }
              // link={"/easyReport"}
              circleColorOne={"#F48710"}
              circleColorTwo={"#AA3F76"}
              productName={"EasyReport"}
            />
          </Grid2>
          <Grid2 item size={styles.sizeGridItem}>
            <MyCard
              img={<MapsSvg />}
              clientImg={easyMapsLogo}
              bgcolor={theme.palette.background.paper}
              target=""
              navigateTo="/easyMaps"
              disabled={
                verifyModules === "true"
                  ? !modulos?.planoEasyMaps || modulos?.status === 2
                  : false
              }
              // link={"/easyMaps"}
              circleColorOne={"#EA4860"}
              circleColorTwo={"#2dc988"}
              productName={"EasyMaps"}
            />
          </Grid2>

          <Grid2 item size={styles.sizeGridItem}>
            <MyCard
              img={<LogSvg />}
              clientImg={easyLogsLogo}
              bgcolor={theme.palette.background.paper}
              target=""
              link={"/easyLog"}
              circleColorOne={"#f04046"}
              circleColorTwo={"#41414188"}
              disabled={
                verifyModules === "true"
                  ? !modulos?.planoEasyLogs || modulos?.status === 2
                  : false
              }
              productName={"EasyLog"}
            />
          </Grid2>
        </Grid2>
        {/*       <Inbox /> */}
      </Box>
    </Box>
  );
}
